import { createMuiStyles } from '../../../utils/mui';

export const guestUserQualificationFormStyles = createMuiStyles({
  tabContainer: {
    borderBottom: 1,
    borderColor: 'divider',
    px: 2.5,
    '.MuiTabs-root': {
      minHeight: 'auto',
    },
    '.MuiTabs-indicator': {
      display: 'none',
    },
  },
  tab: {
    mr: 2,
    borderTopLeftRadius: '0.25rem',
    borderTopRightRadius: '0.25rem',
    minHeight: 'auto',
    bgcolor: 'common.white',
    border: 1,
    borderColor: 'divider',
    borderBottom: 0,
    px: 2,
    py: 1,
    '&.Mui-selected': {
      bgcolor: 'primary.main',
      color: 'common.white',
      borderColor: 'primary.main',
    },
  },
});
